import $ from "jquery";
import Api from "../App/Api";

const ReportList = (() => {
  return {
    initialize: function (selector) {
      const $status = $(selector);
      if ($status.length > 0) {
        Api.showReportList($status.val());
        $status.change(function () {
          Api.showReportList($status.val());
        });
      }
    }
  };
})();

module.exports = ReportList;
